/* global axios */
import ApiClient from '../ApiClient';

class InstagramChannel extends ApiClient {
  constructor() {
    super('instagram', { accountScoped: true });
  }

  generateAuthorization(payload) {
    return axios.post(`${this.url}/authorization`, payload);
  }

  embeddedSignup(payload) {
    return axios.post(`${this.url}/embedded_signup`, payload);
  }
}

export default new InstagramChannel();
